import { AuthSessionSchema, type AuthSession } from "@herskin/contracts";
import { Button, InlineError } from "@herskin/ui";
import { IconSparkles as Sparkles } from "@tabler/icons-react";
import { type FormEvent, useState } from "react";
import { api } from "./api";
import { ProductSubtitle } from "./ProductBrand";

interface LoginScreenProps {
  onSuccess: (auth: AuthSession) => void;
}

/** 独立的认证入口；主应用只负责在认证状态之间切换。 */
export function LoginScreen({ onSuccess }: LoginScreenProps) {
  const [username, setUsername] = useState(
    () => localStorage.getItem("herskin:last-username") ?? "owner",
  );
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event: FormEvent) => {
    event.preventDefault();
    setSubmitting(true);
    setError("");
    try {
      const body = await api<unknown>("/api/auth/login", {
        method: "POST",
        body: JSON.stringify({ username: username.trim(), password }),
      });
      localStorage.setItem("herskin:last-username", username.trim());
      onSuccess(AuthSessionSchema.parse(body));
    } catch (caught) {
      setError(caught instanceof Error ? caught.message : "登录失败");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="login-page">
      <section className="login-card" aria-labelledby="login-title">
        <div className="brand-mark" aria-hidden="true">
          <Sparkles size={24} />
        </div>
        <ProductSubtitle className="herskin-signature--login" />
        <h1 id="login-title">欢迎回到 HerSkin</h1>
        <p className="login-copy">
          登录后连接服务器上的 Hermes。凭证只发送给 HerSkin，不进入浏览器存储。
        </p>
        <form onSubmit={submit}>
          <label htmlFor="username">登录账号</label>
          <input
            id="username"
            type="text"
            autoComplete="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            autoFocus
          />
          <label htmlFor="password">访问口令</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          {error ? <InlineError title="登录失败" message={error} /> : null}
          <Button
            type="submit"
            variant="primary"
            size="lg"
            isLoading={submitting}
            disabled={!username.trim() || !password}
          >
            登录 HerSkin
          </Button>
        </form>
      </section>
    </main>
  );
}
